const AB_TEST_STATUS_TRANSITIONS = {
  Draft: ['ReadyForTest'],
  ReadyForTest: ['Testing', 'Fixing'],
  Testing: ['RequiredChanges', 'Tested'],
  RequiredChanges: ['Fixing'],
  Fixing: ['ReadyForTest'],
  Tested: ['Start'],
  Start: ['StoppedDistribution'],
  StoppedDistribution: ['FinishedTest'],
  FinishedTest: ['Archived', 'FailedABTest'],
  FailedABTest: ['FailedABTest'],
  Archived: ['Archived'],
}

const ORDERED_STATUSES = [
  'Draft',
  'ReadyForTest',
  'Testing',
  'RequiredChanges',
  'Fixing',
  'Tested',
  'Start',
  'StoppedDistribution',
  'FinishedTest',
  'FailedABTest',
  'Archived',
]
const STATUS_ALIASES = {
  draft: 'Draft',
  readyfortest: 'ReadyForTest',
  testing: 'Testing',
  requiredchanges: 'RequiredChanges',
  fixing: 'Fixing',
  tested: 'Tested',
  start: 'Start',
  stoppeddistribution: 'StoppedDistribution',
  finishedtest: 'FinishedTest',
  failedabtest: 'FailedABTest',
  archived: 'Archived',
  release: 'Start',
}

function normalizeStatus(status) {
  const raw = String(status || 'Draft').trim()
  const mapped = STATUS_ALIASES[raw.toLowerCase()] || raw
  return ORDERED_STATUSES.includes(mapped) ? mapped : 'Draft'
}

export function getAvailableAbTestStatuses(abTest) {
  const currentStatus = normalizeStatus(abTest?.status)
  const fromApi = Array.isArray(abTest?.availableStatuses)
    ? abTest.availableStatuses.map((item) => normalizeStatus(item))
    : null
  if (fromApi && fromApi.length > 0) {
    const unique = Array.from(new Set(fromApi))
    return ORDERED_STATUSES.filter((item) => unique.includes(item))
  }
  const nextStatuses = AB_TEST_STATUS_TRANSITIONS[currentStatus] || []
  const unique = Array.from(new Set([currentStatus, ...nextStatuses]))
  return ORDERED_STATUSES.filter((item) => unique.includes(item))
}

export function canTransitionAbTestStatus(currentStatus, nextStatus) {
  const normalizedCurrent = normalizeStatus(currentStatus)
  const normalizedNext = normalizeStatus(nextStatus)
  return (AB_TEST_STATUS_TRANSITIONS[normalizedCurrent] || []).includes(normalizedNext)
}
